"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = exports.TEST_ID_PRODUCT_CARD = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var Card_1 = require("../../atoms/Card/Card");
var CardFooter_1 = require("../../atoms/Card/CardFooter");
var CardHeader_1 = require("../../atoms/Card/CardHeader");
var SplitButton_1 = require("../../atoms/SplitButton/SplitButton");
exports.TEST_ID_PRODUCT_CARD = "ProductCard";
var ProductCard = function (_a) {
    var bgImage = _a.bgImage, header = _a.header, subHeader = _a.subHeader, splitButtonLeftText = _a.splitButtonLeftText, splitButtonRightText = _a.splitButtonRightText, onSplitButtonClick = _a.onSplitButtonClick, infoActionText = _a.infoActionText, onInfoClick = _a.onInfoClick, _b = _a.gradient, gradient = _b === void 0 ? "darkCorners" : _b, _c = _a.csx, csx = _c === void 0 ? {} : _c;
    return (theme_ui_1.jsx(Card_1.Card, { bgImage: bgImage, gradient: gradient, sx: __assign({}, csx) },
        theme_ui_1.jsx(CardHeader_1.CardHeader, { header: header, subHeader: subHeader }),
        theme_ui_1.jsx(CardFooter_1.CardFooter, null,
            theme_ui_1.jsx(SplitButton_1.SplitButton, { onClick: onSplitButtonClick, leftText: splitButtonLeftText, rightText: splitButtonRightText }),
            theme_ui_1.jsx(theme_ui_1.Button, { sx: {
                    marginLeft: [0, "25px", "25px", 0, "25px"],
                    marginTop: [theme_1.theme.space[2], 0, 0, theme_1.theme.space[2], 0],
                    p: 0,
                    background: "transparent",
                }, onClick: onInfoClick },
                theme_ui_1.jsx(theme_ui_1.Text, { variant: "text.p", sx: {
                        fontSize: 2,
                        letterSpacing: "0.06em",
                        lineHeight: "151.19%",
                    } }, infoActionText)))));
};
exports.ProductCard = ProductCard;
